import React from 'react';

export const SiteConfigContext = React.createContext();

// This component will provide the site config to any descendants that ask for it
export const SiteConfigProvider = ({ config, children }) => (
  <SiteConfigContext.Provider value={config}>
    {children}
  </SiteConfigContext.Provider>
);